import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import { Apitoken, Authtoken ,base_url } from "../Global";
import PropTypes from 'prop-types';
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';


import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
import AddOperationModel from "../rawmaterialscratesfollowup/AddOperationModel";
import CrateFollowUpUpdate from '../rawmaterialscratesfollowup/CrateFollowUpUpdate';

const RawMaterialCreatesFollowUps = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  // const [customersList, setCustomersList] = useState([]);  
  const [permission, setPermission] = useState({});
  const [showmodelEdit, setshowmodelEdit] = useState(false);
  const [showmodel, setshowmodel] = useState(false);
  const [groupbyplatenumber, setGroupbyplatenumber] = useState([]);
  const [groupbysupplier, setGroupbysupplier] = useState([]);
   let season_id = localStorage.getItem("season_id");
  const [selectedItemId, setSelectedItemId] = useState(null);

  useEffect(() => {
        setPermission(FindModuleById(448)); 
    console.log(permission);
        let para = {season_id:season_id};

      axios.post("/rawmaterials-boxes",para,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.materials);
          setGroupbyplatenumber(response.data.data.materials_boxes);         
          setGroupbysupplier(response.data.data.materials_supplier);         
  
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  



  }, []);
  
  const addForm = () => {
    console.log('add');
    setshowmodel(true);
  };

  const handleClose = () => {
    setshowmodel(false);
    setshowmodelEdit(false);
    setSelectedItemId(null);
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const PlateNumberCell = ({ row }) => (
    <a href={`/crates-follow-up-platenumber/${row.original.plate_number}`} className="">
      {row.original.plate_number}
    </a>
  );
  
  const DifferenceCell = ({ row }) => (
    <span>{row.original.sum_boxes_out - row.original.sum_boxes_in}</span>
  );

  PlateNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        plate_number: PropTypes.string.isRequired,
      }),
    }).isRequired,
  };
  
  DifferenceCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_boxes_out: PropTypes.number.isRequired,
        sum_boxes_in: PropTypes.number.isRequired,
      }),
    }).isRequired,
  };
  
  const columns_platenumber = [
    {
      header: 'Plate Number',
      accessorKey: 'plate_number', // 🔑 This enables filtering and sorting

      Cell: PlateNumberCell, // Use extracted component
    },
    {
      accessorKey: 'driver_name',
      header: 'Driver Name',
    },
    {
      accessorKey: 'sum_boxes_out',
      header: 'Total Boxes OUT',
    },
    {
      accessorKey: 'sum_boxes_in',
      header: 'Total Boxes IN',
    },
    {
      header: 'Difference',
      accessorFn: row => row.sum_boxes_out - row.sum_boxes_in, // 🧠 Enables filtering & sorting

      Cell: DifferenceCell, // Use extracted component
    },
    {
      accessorKey: 'total_entries',
      header: 'Total Entries',
    },
  ];

 // ✅ Location Cell Component
// const supplierColumn = ({ row }) => (
//   <a href={`/raw-materials-groupbylocation/${row.original.supplier}`} className="">
//     {row.original.supplier_name ? row.original.supplier_name.name : ''}
//   </a>
// );
const supplierColumn = ({ row }) => {
  //console.log('Row data:', row.original);
  return (
    <a href={`/crates-follow-up-supplier/${row.original.supplier}`} className="">
      {row.original.supplier ? row.original.supplier : ''}
    </a>
  );
};
supplierColumn.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      supplier: PropTypes.string,
      
    }),
  }).isRequired,
};


const DifferenceCellSupplier = ({ row }) => (
  <span>{row.original.sum_boxes_out - row.original.sum_boxes_in}</span>
);



DifferenceCellSupplier.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      sum_boxes_out: PropTypes.number.isRequired,
      sum_boxes_in: PropTypes.number.isRequired,
    }),
  }).isRequired,
};


  const columns_supplier = [
 
    {
    //   header: 'Supplier Name',
    //  accessorKey: 'supplier_name',
    //   Cell: supplierColumn,
    //   enableGlobalFilter: true,
    header: 'Supplier Name',
    accessorKey: 'supplier', // Use the correct path to the name
    Cell: supplierColumn,
    //enableGlobalFilter: true, // Enable filtering
    },
 
    {
      accessorKey: 'boxes_out',
      header: 'Total Boxes OUT',
    },
    {
      accessorKey: 'boxes_in',
      header: 'Total Boxes IN',
    },
    {
      accessorKey: 'difference',
      header: 'Difference',
    },
    // {
    //   header: 'Difference',
    //   Cell: DifferenceCell, // Use extracted component
    // },
    // {
    //   header: 'Difference',
    //   accessorFn: (row) => row.sum_boxes_out - row.sum_boxes_in, // Calculate the difference for filtering
    //   Cell: DifferenceCellSupplier, // Keep your custom component for display
    //   enableGlobalFilter: true,
    // },
    {
      accessorKey: 'total_entries',
      header: 'Total Entries',
    },
  ];

 

    const LotNumberCell = ({ row }) => (
      <a href={`/raw-materials-view/${row.original.id}`} className="">
        {row.original.lot_number}
      </a>
    );
    
    const DifferenceCell2 = ({ row }) => (
      <span>{row.original.boxes_out - row.original.boxes_in}</span>
    );
    LotNumberCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          id: PropTypes.number.isRequired,
          lot_number: PropTypes.string.isRequired,
        }),
      }).isRequired,
    };
    
    DifferenceCell2.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          boxes_out: PropTypes.number.isRequired,
          boxes_in: PropTypes.number.isRequired,
        }),
      }).isRequired,
    };
    
    const columns = [
      {
        accessorKey: 'plate_number',
        header: 'Plate Number',
      },
      {
        accessorKey: 'driver_name',
        header: 'Driver Name',
      },
      {
        accessorKey: 'shift_date',
        header: 'Shift Date',
      },
       {
        accessorKey: 'supplier',
        header: 'Supplier',
      },
      // {
      //   header: 'Supplier',
      //   accessorFn: (row) => (row.supplier_name ? row.supplier_name.name : ''),
      // },
      {
        header: 'Lot Number',
        accessorFn: (row) => row.lot_number,
        Cell: LotNumberCell, // Use extracted component
      },
      {
        accessorKey: 'boxes_out',
        header: 'Boxes OUT',
      },
      {
        accessorKey: 'boxes_in',
        header: 'Boxes IN',
      },
      {
        header: 'Difference',
        Cell: DifferenceCell2, // Use extracted component
      },
    ];

 
    const downloadExcel = (e) => {
      console.log(e);
      let season_id = localStorage.getItem("season_id");
        window.open(`${base_url}/rawmaterials-boxes-excel?season_id=${season_id}`, '_blank');
        $("#loader-image2").addClass('loader-hide2');
        $("#loader-image2").removeClass('loader-show2');
    }
  
 
    const downloadExcelGroupByPallet = (e) => {
      console.log(e);
      let season_id = localStorage.getItem("season_id");
        window.open(`${base_url}/rawmaterials-boxes-excel-groupby?season_id=${season_id}`, '_blank');
        $("#loader-image2").addClass('loader-hide2');
        $("#loader-image2").removeClass('loader-show2');
    }
      
  const deleteItemManual = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/crates-follow-up/delete-manual/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/crates-follow-up/";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  

const updateItemManual = (item)=>{
  
    setSelectedItemId(item);
    console.log("item");
    console.log(item);
   setshowmodelEdit("showCategory")
  
}
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Crates Follow Up</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Crates Follow Up</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission?.add == 1 && (
                  <button  onClick={() => addForm()} className="btn btn-primary">
                    <i className="fas fa-plus"></i>
                  </button>
                )}
                &nbsp;&nbsp;
                  {permission?.list == 1 && (
                    <button
                    className="btn btn-primary"
                    onClick={() => downloadExcelGroupByPallet()}
                  >
                    Group By Plate Number<i className="fa fa-file-excel-o"></i>   <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                  </button> 
                  )}  &nbsp;&nbsp;
                  {permission?.list == 1 && (
                     <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                   Crates Follow Up Listing <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                  </button>  
                  )}
                   
                
                 
           
              </div>
            </div>
          </div>

      
            <div className="row">  
              
                 

            <section className="comp-section">
                <div className="row">
                <div className="col-md-12">
                {permission?.list == 1 && (
                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                        <li className="nav-item">
                            <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab">Group By Plate Number</a>                                  
                        </li>
                      
                        <li className="nav-item" >
                            <a className="nav-link" href="#listing-supplier" data-bs-toggle="tab"> Group By Supplier</a>                                   
                        </li>      
                        <li className="nav-item" >
                            <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> listing</a>                                   
                        </li>               
                        </ul>
                        <div className="tab-content">
                        <div className="tab-pane show active" id="listing-groupby">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columns_platenumber} data={groupbyplatenumber} 
                                      enableColumnOrdering
                                      enablePinning
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                                                     
                          <div className="tab-pane " id="listing-all">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                                columns={columns}
                                                data={data}
                                                enableColumnOrdering
                                                enablePinning
                                                enableRowActions
                                                renderRowActionMenuItems={({ row }) => {
                                                  const items = [];
                                                  if (row.original.add_type === "manual" && permission?.update == 1) {
                                                    items.push(
                                                      <MenuItem key="update" onClick={() => updateItemManual(row.original.id)}>
                                                        Edit
                                                      </MenuItem>
                                                    );
                                                  }
                                                  if (row.original.add_type === "manual" && permission?.delete == 1) {
                                                    items.push(
                                                      <MenuItem key="delete" onClick={() => deleteItemManual(row.original.id)}>
                                                        Delete
                                                      </MenuItem>
                                                    );
                                                  }

                                                  

                                                  return items;
                                                }}
                                              />

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          
                          </div>                                
                                                       
                          <div className="tab-pane " id="listing-supplier">
                              <div className="row"   id="listing-followup2">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <MaterialReactTable columns={columns_supplier} data={groupbysupplier} 
                                              enableColumnOrdering
                                              enablePinning
                                              enableColumnFilterModes
                                              enableGlobalFilter={true} // Add this line
                                              // enableGrouping
                                            />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          
                          </div> 
                        </div>                             
                    </div>
                    </div>
                )}
                </div>
                </div>
            </section>
            
                    <AddOperationModel show={showmodel} handleClose={handleClose} />
                         <CrateFollowUpUpdate  itemId={selectedItemId} show={showmodelEdit} handleClose={handleClose} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RawMaterialCreatesFollowUps;
